import React, { useState } from "react";
import { FaUserPlus, FaUserMinus, FaTrashAlt, FaEdit, FaUserShield } from "react-icons/fa";

export default function UserTable({ users, deleteUser, setSelectedUserId, setSelectedUserEmail, setAdminRole, onEditUser, selectedUserId }) {
  const [confirmingDeleteId, setConfirmingDeleteId] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  const handleConfirmDelete = async (userId) => {
    setDeletingId(userId);
    try {
      await deleteUser(userId);
    } finally {
      setDeletingId(null);
      setConfirmingDeleteId(null);
    }
  };

  const handleAdminToggle = (userId) => {
    const isAdmin = users.find((u) => u._id === userId).admin;
    setAdminRole(userId, !isAdmin);
  };

  return (
    <div className="space-y-2 max-h-[32rem] overflow-y-auto pr-1">
      {users.map((currentUser) => (
        <div
          key={currentUser._id}
          className={`rounded-lg border overflow-hidden transition-colors ${
            selectedUserId === currentUser._id
              ? 'border-blue-300 bg-blue-50'
              : 'border-gray-200 bg-gray-50'
          }`}
        >
          {confirmingDeleteId === currentUser._id ? (
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 bg-red-50 px-4 py-3">
              <p className="text-xs sm:text-sm text-red-700 font-medium truncate">
                Supprimer « {currentUser.email} » ?
              </p>
              <div className="flex gap-2 shrink-0">
                <button
                  onClick={() => handleConfirmDelete(currentUser._id)}
                  disabled={deletingId === currentUser._id}
                  className="bg-red-500 text-white px-3 py-1.5 rounded-lg text-xs sm:text-sm font-medium hover:bg-red-600 transition-colors disabled:opacity-50"
                >
                  {deletingId === currentUser._id ? 'Suppression...' : 'Confirmer'}
                </button>
                <button
                  onClick={() => setConfirmingDeleteId(null)}
                  disabled={deletingId === currentUser._id}
                  className="bg-white border border-gray-300 text-gray-600 px-3 py-1.5 rounded-lg text-xs sm:text-sm font-medium hover:bg-gray-100 transition-colors disabled:opacity-50"
                >
                  Annuler
                </button>
              </div>
            </div>
          ) : (
            <div className="flex items-center justify-between gap-3 px-4 py-3">
              <div className="flex items-center gap-2 min-w-0">
                <span className={`text-sm truncate ${currentUser.admin ? 'text-red-600 font-semibold' : 'text-gray-700'}`}>
                  {currentUser.email}
                </span>
                {currentUser.admin && (
                  <FaUserShield className="text-red-500 shrink-0" title="Administrateur" />
                )}
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <FaEdit
                  onClick={() => onEditUser(currentUser._id, currentUser.email)}
                  title="Modifier les informations de l'utilisateur"
                  className="cursor-pointer text-gray-400 hover:text-blue-600 transition-colors"
                />
                {currentUser.admin ? (
                  <FaUserMinus
                    className="cursor-pointer text-gray-400 hover:text-orange-500 transition-colors"
                    onClick={() => handleAdminToggle(currentUser._id)}
                    title="Enlever le rôle admin de l'utilisateur"
                  />
                ) : (
                  <FaUserPlus
                    className="cursor-pointer text-gray-400 hover:text-blue-600 transition-colors"
                    onClick={() => handleAdminToggle(currentUser._id)}
                    title="Ajouter le rôle admin à l'utilisateur"
                  />
                )}
                <FaTrashAlt
                  onClick={() => setConfirmingDeleteId(currentUser._id)}
                  title="Supprimer l'utilisateur"
                  className="cursor-pointer text-gray-400 hover:text-red-600 transition-colors"
                />
              </div>
            </div>
          )}
        </div>
      ))}

      <div className="flex items-center gap-2 text-xs text-gray-400 pt-2">
        <FaUserShield className="text-red-400" />
        Icône rouge = compte administrateur
      </div>
    </div>
  );
}